import { render, staticRenderFns } from "./tax_type.vue?vue&type=template&id=8c025fc4"
import script from "./tax_type.vue?vue&type=script&lang=js"
export * from "./tax_type.vue?vue&type=script&lang=js"
import style0 from "./tax_type.vue?vue&type=style&index=0&id=8c025fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports